<div *ngIf="offer" class="offer-card-container">
    <div class="offer-card" [class.disabled]="!offer.canEdit">
        <div class="offer-header">
            <div class="offer-info">
                <div class="offer-meta1">
                    <h3 class="offer-title">
                        <img src="./assets/images/icons/book_mark.png" alt="book_mark">
                        <span>{{ offer.price | priceFormat }}</span>
                    </h3>
                    <span class="creation-date">
                    {{ offer.createdAt }}
                </span>
                </div>
                <div class="offer-meta2">
                    <div class="status-badge">
                        <span class="status-dot" [ngClass]="getOfferStatusClass()"></span>
                        <span class="status-text">{{ getOfferStatusText() }}</span>
                    </div>
                    <button *ngIf="offer.canEdit" class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                        <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                    </button>
                </div>
            </div>

            <!--<div class="offer-actions" *ngIf="offer.canEdit">
                <button class="icon-btn edit-btn" [title]="'Modifier l\'offre'" (click)="editOffer()">
                    <img src="./assets/images/icons/edit.png" alt="Edit">
                </button>
                <button class="icon-btn delete-btn" [title]="'Supprimer l\'offre'" (click)="confirmDeleteOffer()">
                    <img src="./assets/images/icons/trash.png" alt="Delete">
                </button>
            </div>-->
        </div>

        <div class="offer-note">
            <p>{{ offer.description }}</p>
        </div>

        <div class="offer-content">

            <div class="agents-section">
                <div *ngIf="!offer.agents || offer.agents.length === 0" class="no-agents">
                    <p>Aucun agent assigné</p>
                </div>

                <div *ngIf="offer.agents && offer.agents.length > 0" class="agents-list">
                    <div class="agents-list-header" (click)="toggleAgentsList($event)">
                        <img src="./assets/images/icons/user_check_gray.png" alt="user check icon">
                        <span>Agents assigner ( <strong>{{offer.agents.length}}</strong> )</span>
                        <img src="./assets/images/icons/arrow-down.png" alt="arrow down icon" class="arrow-icon" [@rotateArrow]="isAgentsExpanded ? 'open' : 'closed'">
                    </div>

                    <div class="agents-chips-container" [@slideInOut]="isAgentsExpanded ? 'open' : 'closed'">
                        <div *ngFor="let agent of offer.agents" class="agent-chip">
                            <div class="agent-image-col">
                                <img [src]="agent.profileImage || './assets/images/icons/user-default-icon.png'" [alt]="agent.firstName" class="agent-image" [class.full]="agent.profileImage">
                            </div>
                            <div class="agent-content-col">
                                <span class="agent-name">{{ agent.firstName }} {{ agent.lastName }}</span>
                                <div class="agent-info">
                                    <span class="agent-email">{{ agent.email }}</span>
                                    <span class="agent-email">{{ agent.age }} ans</span>
                                    <span class="agent-email">{{ agent.height }} cm</span>
                                </div>
                            </div>

                            <div class="agent-action-col">
                                <button *ngIf="offer.canAddAgents" class="btn" (click)="confirmDeleteAgnet(agent)" title="Retirer cet agent">
                                    <img src="./assets/images/icons/user_remove.png" alt="user remove icon">
                                    <span>Supprimer</span>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="popup-menu" *ngIf="menuOpen && offer.canEdit">
        <div class="arrow"></div>
        <ul>
            <li (click)="editOffer()">
                <img src="./assets/images/icons/edit.png" alt="Edit"> Modifier
            </li>
            <li (click)="confirmDeleteOffer()" class="delete-item">
                <img src="./assets/images/icons/trash.png" alt="Delete"> Supprimer
            </li>
        </ul>
    </div>
</div>


<!-- Delete Offer Confirmation Modal -->
<div class="confirmation-modal-overlay" *ngIf="showDeleteOfferModal && offer">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteOfferModal()">×</button>
        </div>
        <div class="modal-body">
            <p class="m-0">Êtes-vous sûr de vouloir supprimer cette offre <br><strong>{{ offer.price | priceFormat }}</strong> ?
            </p>
            <div class="status-badge mb-2">
                <span class="status-dot" [ngClass]="getOfferStatusClass()"></span>
                <span class="status-text">{{ getOfferStatusText() }}</span>
            </div>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteOfferModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="deleteOffer()">Supprimer</button>
        </div>
    </div>
</div>

<div class="confirmation-modal-overlay" *ngIf="showDeleteAgentModal && offer && selectedAgent">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteAgentModal()">×</button>
        </div>
        <div class="modal-body">
            <p class="">Êtes-vous sûr de vouloir supprimer l'agent : <br><strong>{{ selectedAgent.firstName +" "+ selectedAgent.lastName }}</strong>
                <br>depuis l'offre : <strong>{{ offer.price | priceFormat }}</strong> ?
            </p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteAgentModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="deleteAgent()">Supprimer</button>
        </div>
    </div>
</div>